// Generated by `npm --workspace @pleio/icons run generate`, do not edit.
import { type ForwardedRef, forwardRef } from 'react'

import type { IconProps } from '../types'

export const ArrowLeftIcon = forwardRef<SVGSVGElement, IconProps>((
    { title, titleId, ...props }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14" display="block" focusable="false" role="img" aria-hidden="true" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g id="arrow-left" fill="none" fillRule="evenodd" stroke="none"><path id="Path" fill="currentColor" d="M14.004 5.496v3h-7.62l2.741 2.742-2.121 2.122L.64 6.996 7.004.632l2.121 2.121-2.742 2.742z" /></g></svg>
))
